import { v4 as uuidv4 } from 'uuid';
import { getRandomIconUrl } from 'Shared/helpers';

export const reportOptions = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20 or more',
].map(el => {
  return { label: String(el), value: String(el) };
});

export const selectStyles = {
  control: base => ({ ...base, minHeight: '32px', height: '32px' }),
};

export function generateEmptyWorkspace() {
  const uuid = uuidv4();
  return { uuid, avatar: { profilePictureUrl: getRandomIconUrl(uuid) } };
}

export function changeArray(count, action, operator) {
  for (let i = 0; i < count; i += 1) {
    action(operator, generateEmptyWorkspace());
  }
}

export function mutateArray(newValue, prevValue, push, pop, operator) {
  const count = Number(newValue);
  const diff = Math.abs(count - prevValue);
  if (count > prevValue) return changeArray(diff, push, operator);
  return changeArray(diff, pop, operator);
}
